import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../../_services/dialog.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Subscriber } from '../../../_models/fundraising/ppw/Subscriber';
import { PledgePerWinService } from '../../../_services/fundraising/pledgePerWin.service';
import { PledgePerWin } from '../../../_models/fundraising/ppw/PledgePerWin';
import { PledgePerWinSubscriber } from '../../../_models/fundraising/ppw/PledgePerWinSubscriber';

@Component({
    templateUrl: './ppw-subscribers-details-modal.component.html',
    styleUrls: ['./ppw-subscribers-details-modal.component.css']
  })

export class PledgePerWinSubscriberDetailsModalComponent implements OnInit {

    public subscriber: Subscriber;
    public currentSubscriptions: PledgePerWinSubscriber[];

    public form: FormGroup;

    public viewRef: ViewContainerRef;

    constructor(
        private bsModalRef: BsModalRef,
        private ppwService: PledgePerWinService,
        private fb: FormBuilder,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private currencyPipe: CurrencyPipe,
        private datePipe: DatePipe
      ) { }

    ngOnInit () {

        const activeSubscriptions = this.subscriber.subscriptions.filter(sub => !sub.cancelled);
        this.currentSubscriptions = activeSubscriptions;

        this.initForm(this.subscriber);
    }

    initForm (subscriberDetails: Subscriber) {

        this.form = this.fb.group({
            fullName: [subscriberDetails.firstName + ' ' + subscriberDetails.lastName],
            phone: [subscriberDetails.phone],
            email: [subscriberDetails.email],
            totalAmountPledged: [this.currencyPipe.transform(subscriberDetails.totalAmountPledged / 100)],
        });
        
        this.form.disable();
    }

    close () {
      
      this.bsModalRef.hide();
    }
}